export default __webpack_public_path__ + "static/v-883b6d048f7f61756df0eec4cc025ddc.gif";